module.exports = {
      id: "bell-usage",
      viewBox: "0 0 20 22.857",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#bell",
      toString: function () {
        return this.url;
      }
    }